const subscribers = new Set();
let initialized = false;

function notify() {
  const v = canInstall();
  subscribers.forEach((fn) => fn(v));
}

export function initPwa() {
  if (initialized) return;
  initialized = true;
  // The event is captured early in index.html and stored on window.deferredPWAPrompt.
  // We just listen for the relay events to update the UI.
  window.addEventListener("pwa-available", notify);
  window.addEventListener("pwa-installed", notify);
  // Fallback listeners in case index.html script didn't run.
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.deferredPWAPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    window.deferredPWAPrompt = null;
    notify();
  });
}

export function canInstall() {
  return !!window.deferredPWAPrompt;
}

export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

export async function promptInstall() {
  const prompt = window.deferredPWAPrompt;
  if (!prompt) return "unavailable";
  prompt.prompt();
  const { outcome } = await prompt.userChoice;
  window.deferredPWAPrompt = null;
  notify();
  return outcome;
}

export function onInstallChange(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}
